import { useContext, useEffect } from 'react';
import {Navigate } from "react-router-dom";
import UnauthorizedBlock from '../components/UnauthorizedBlock/UnauthorizedBlock'
import { AuthContext } from "../context/authContext";

const HomePage = () => {
  
    const {currentUser} = useContext(AuthContext);

   
  useEffect(() => {document.title = "Главная"}, [])
  
  if(currentUser){
    if(currentUser.admin) return <Navigate to="/admin"/>
    else if(currentUser.name) return <Navigate to="/test"/>
  }
  

    return (
        <>
   
          <UnauthorizedBlock showReg={currentUser? false : true}/>
        </>
        
          
        
    )
}

export default HomePage